/**
 * Copyright IBM Corp. 2022, 2026
 */

/**
 * This component is intentionally left as a JSX,
 * in anticipation of a full refactor of case
 * study pages to Materia pages.
 */

'use client'

import useProductMeta from '@web/product-meta'
import Image from 'next/image'

export const CustomerBackground = ({ name, logo, brand, children }) => {
	const productMeta = useProductMeta(brand)
	const { themeClass } =
		brand === 'neutral' ? { themeClass: 'neutral' } : productMeta
	return (
		<div className={`customer-background-container ${themeClass}`}>
			<section className={`customer-background`}>
				<div className="g-grid-container">
					<header>
						<div>
							<h3 className="heading">
								<Image
									src={logo.url}
									width={logo.width}
									height={logo.height}
									alt={name}
								/>
							</h3>
						</div>
					</header>
					<div className="content g-type-body-large">{children}</div>
				</div>
			</section>
		</div>
	)
}

export const CustomerBackgroundFromCMS = ({ content, ...props }) => (
	<CustomerBackground {...props}>
		<span dangerouslySetInnerHTML={{ __html: content }} />
	</CustomerBackground>
)

export default CustomerBackground
